/* eslint-disable ember/classic-decorator-hooks, ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get, ember/no-observers, ember/no-runloop, ember/require-computed-property-dependencies */
import { tracked } from '@glimmer/tracking';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import { cancel, debounce } from '@ember/runloop';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import DynamicFieldBase from '@linc-technologies/linced-common/components/dynamic-field-base';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import Scopes from '@linc-technologies/linced-common/enums/scopes';
import { JurisdictionalIdValidations } from 'linced-app/utils/fields';
import { classNames } from '@ember-decorators/component';
import { observes } from '@ember-decorators/object';

@classNames('id-search-field')
export default class IdSearchField extends DynamicFieldBase {
  @service
  session;

  @service
  permissions;

  @service
  students;

  Jurisdiction = Jurisdiction;

  @alias('session.school.jurisdiction')
  jurisdiction;

  @tracked readOnly = false;
  originalValue = '';
  @tracked
  searchTimer = null;
  @tracked
  searchResponse = null;
  validations = JurisdictionalIdValidations;

  @computed('entity.jurisdiction')
  get validate() {
    // If we don't have/know the jurisdiction, accept anything and everything.
    return (
      this.get(`validations.${this.get('entity.jurisdiction')}`) ?? (() => true)
    );
  }

  @computed('entity.jurisdiction')
  get idValidations() {
    let field = this.field;
    return [
      {
        message: `Please enter a valid ${field.get('label')}.`,
        validate: (value) => isEmpty(value) || this.validate(value),
      },
    ];
  }

  @computed('validate', 'entityField.value')
  get isValid() {
    return this.validate(this.entityField.get('value'));
  }

  @computed('readOnly', 'session.scopes.[]')
  get disabled() {
    return this.readOnly || !this.permissions.meet(Scopes.TENANT_ADMIN);
  }

  @observes('entityField.value')
  _watchValue() {
    let fieldValue = this.entityField.get('value');
    // If it matches the learner's current jurisdictionalId, don't do anything.
    if ((this.entity.get('jurisdictionalId') ?? '') === fieldValue) {
      return;
    }

    // Push the value into the top level Person record's jurisdictionalId property.
    this.entity.set('jurisdictionalId', fieldValue);

    // Initiate search if non-empty and valid.
    if (!isEmpty(fieldValue) && this.validate(fieldValue)) {
      this.searchTimer = debounce(this, 'search', 200, false);
    } else {
      if (!isEmpty(this.searchTimer)) {
        cancel(this.searchTimer);
        this.searchTimer = null;
      }
    }
  }

  init() {
    super.init(...arguments);
    this.originalValue = this.entityField.get('value');
  }

  search() {
    this.students
      .searchByJurisdictionalId(this.entity, this.entity.jurisdictionalId)
      .then((searchResponse) => {
        this.searchResponse = searchResponse;
      });
  }
}
